"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@material-ui/core/Button");
var FormHelperText_1 = require("@material-ui/core/FormHelperText");
var Grid_1 = require("@material-ui/core/Grid");
var Link_1 = require("@material-ui/core/Link");
var TextField_1 = require("@material-ui/core/TextField");
var withStyles_1 = require("@material-ui/styles/withStyles");
var Env_1 = require("src/Env");
var ErrorBoundary_1 = require("src/ErrorBoundary");
var Forms_1 = require("src/Forms");
var Routing_1 = require("src/Routing");
var Telemetry_1 = require("src/Telemetry");
var SignUp = /** @class */ (function (_super) {
    __extends(SignUp, _super);
    function SignUp(props) {
        var _this = _super.call(this, props) || this;
        _this.firstNameInput = React.createRef();
        _this.lastNameInput = React.createRef();
        _this.passwordInput = React.createRef();
        _this.confirmPasswordInput = React.createRef();
        _this.emailInput = React.createRef();
        _this.confirmEmailInput = React.createRef();
        _this.universityId = 0;
        /**
         * Store the updated university value
         */
        _this.universityValueChanged = function (_a) {
            var value = _a.value;
            _this.universityId = value;
        };
        /**
         * Handle form submission, call provided listener
         */
        _this.onSubmit = function (e) {
            e.preventDefault();
            if (_this.props.status === 'waiting') {
                return;
            }
            /* istanbul ignore next */
            if (_this.emailInput.current === null) {
                Telemetry_1.Sentry.logError(new Error('Email input not registerd to component'));
                return _this.props.displayMessage('Email Input ref associate with form field', 'error');
            }
            /* istanbul ignore next */
            var confirmEmail = (_this.confirmEmailInput.current === null) ? '' :
                _this.confirmEmailInput.current.value.trim();
            /* istanbul ignore next */
            if (_this.passwordInput.current === null) {
                Telemetry_1.Sentry.logError(new Error('Password input not registerd to component'));
                return _this.props.displayMessage('Password ref not associate with form field', 'error');
            }
            /* istanbul ignore next */
            var confirmPassword = (_this.confirmPasswordInput.current === null) ? '' :
                _this.confirmPasswordInput.current.value.trim();
            /* istanbul ignore next */
            if (_this.firstNameInput.current === null) {
                return _this.props.displayMessage('First Name ref not associate with form field', 'error');
            }
            /* istanbul ignore next */
            if (_this.lastNameInput.current === null) {
                return _this.props.displayMessage('Last Name not associate with form field', 'error');
            }
            _this.props.onSubmit({
                firstName: _this.firstNameInput.current.value.trim(),
                lastName: _this.lastNameInput.current.value.trim(),
                email: _this.emailInput.current.value.trim(),
                confirmEmail: confirmEmail,
                password: _this.passwordInput.current.value.trim(),
                confirmPassword: confirmPassword,
                universityId: _this.universityId
            });
        };
        /**
         * Get the error message for the field
         */
        _this.errorMessageForField = function (fieldName) {
            return _this.props.errors && _this.props.errors[fieldName];
        };
        /**
         * Returns the class name to be applied to a field
         */
        _this.classForField = function (fieldName) {
            return _this.errorMessageForField(fieldName) ?
                _this.props.classes.errorInput :
                _this.props.classes.primaryInput;
        };
        /**
         * Return the error message for a given fieldName
         */
        _this.errorForField = function (fieldName) {
            var errorMessage = _this.errorMessageForField(fieldName);
            if (errorMessage === undefined) {
                return null;
            }
            else {
                return React.createElement(FormHelperText_1.default, { error: true }, errorMessage);
            }
        };
        _this.focusEmail = function () {
            _this.setState({ wasEmailFocused: true });
        };
        _this.focusPassword = function () {
            _this.setState({ wasPasswordFocused: true });
        };
        _this.state = {
            wasEmailFocused: false,
            wasPasswordFocused: false
        };
        return _this;
    }
    SignUp.prototype.render = function () {
        var _a = this.props, classes = _a.classes, _b = _a.status, status = _b === void 0 ? 'ready' : _b, _c = _a.showConfirmFields, showConfirmFields = _c === void 0 ? false : _c;
        var _d = this.state, wasEmailFocused = _d.wasEmailFocused, wasPasswordFocused = _d.wasPasswordFocused;
        var isDisabled = status === 'waiting';
        return (React.createElement("form", { onSubmit: this.onSubmit },
            React.createElement(Grid_1.default, { container: true, direction: "column", className: classes.topGridItem },
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement("img", { src: Env_1.ASSET_ROOT + "Logo-Signin.png", alt: "Rowan Technology" })),
                React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.topGridItem },
                    React.createElement(Grid_1.default, { item: true, className: classes.twoByChild },
                        React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: classes.primaryInput }, variant: "filled", margin: "dense", label: "first name", name: "first_name", required: true, inputProps: { ref: this.firstNameInput } })),
                    React.createElement(Grid_1.default, { item: true, className: classes.twoByChild },
                        React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: classes.primaryInput }, variant: "filled", margin: "dense", label: "last name", name: "last_name", required: true, inputProps: { ref: this.lastNameInput } }))),
                this.props.universityAutoComplete && (React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    this.props.universityAutoComplete(this.universityValueChanged, isDisabled),
                    this.errorForField('universityIdError'))),
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: this.classForField('emailError') }, variant: "filled", margin: "dense", label: "email", name: "email", required: true, onFocus: this.focusEmail, inputProps: { ref: this.emailInput } }),
                    this.errorForField('emailError')),
                (wasEmailFocused || showConfirmFields) && (React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: this.classForField('confirmEmailError') }, variant: "filled", margin: "dense", required: true, label: "confirm email", name: "confirm_email", inputProps: { ref: this.confirmEmailInput } }),
                    this.errorForField('confirmEmailError'))),
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: this.classForField('passwordError') }, placeholder: "password", variant: "filled", margin: "dense", label: "password", name: "password", onFocus: this.focusPassword, required: true, type: "password", inputProps: { ref: this.passwordInput } }),
                    this.errorForField('passwordError')),
                (wasPasswordFocused || showConfirmFields) && (React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: this.classForField('confirmPasswordError') }, variant: "filled", margin: "dense", required: true, label: "confirm password", name: "confirm_password", type: "password", inputProps: { ref: this.confirmPasswordInput } }),
                    this.errorForField('confirmPasswordError'))),
                React.createElement(Forms_1.RequiredFieldsNotice, null),
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(Button_1.default, { disabled: isDisabled, className: classes.fullWidth, variant: "contained", color: "primary", type: "submit", size: "large" }, "sign up")),
                React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.topGridItem },
                    React.createElement(Grid_1.default, { className: classes.twoByChild, container: true, direction: "column" },
                        React.createElement(Grid_1.default, { item: true },
                            React.createElement(Link_1.default, { component: Routing_1.RouterLink('/resetPassword/'), variant: "body1", color: "textPrimary", underline: "none" }, "forgot password?")),
                        React.createElement(Grid_1.default, { item: true },
                            React.createElement(Link_1.default, { component: Routing_1.RouterLink('/resendConfirmation/'), variant: "body1", color: "textPrimary", underline: "none" }, "resend confirmation"))),
                    React.createElement(Grid_1.default, { className: classes.twoByChild, item: true },
                        React.createElement(Link_1.default, { component: Routing_1.RouterLink('/login'), variant: "subtitle2", underline: "none" },
                            React.createElement(Button_1.default, { className: classes.fullWidth, variant: "outlined", color: "primary", size: "large" }, "login")))))));
    };
    return SignUp;
}(React.Component));
exports.default = withStyles_1.default(Forms_1.styles)(ErrorBoundary_1.withDisplayMessage(SignUp));
